import styled from 'styled-components';
import { BIG_NAV_PX_HEIGHT, colorCSS, containerWidths, mediaMinLg, shadow, zIndex } from '../../../styles';
export const DetailWrapper = styled.div `
  overflow: hidden;
  transition: height 0.3s ease;
`;
export const Header = styled.header `
  background-color: ${colorCSS('N900', 0)};
  display: none;
  height: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: background-color 0.6s ease, height 0s linear 0.6s;
  z-index: ${zIndex.headerShroud};
  &[data-open='true'] {
    background-color: ${colorCSS('N900', 0.5)};
    cursor: pointer;
    height: 100vh;
    transition: background-color 0.6s ease, height 0s linear;
  }
  ${mediaMinLg(`
    display: block;
  `)}
`;
export const InnerHeader = styled.div `
  background-color: ${({ startTransparent }) => colorCSS('N0', startTransparent ? 0 : 1)};
  cursor: default;
  position: fixed;
  top: 0;
  transition: 0.5s background-color ease, 0.5s box-shadow ease;
  width: 100vw;
  z-index: ${zIndex.header};
  &[data-active='true'],
  &:hover {
    background-color: ${colorCSS('N0', 1)};
    box-shadow: ${shadow.normal};
  }
`;
export const NavBar = styled.div `
  align-items: stretch;
  display: flex;
  height: ${BIG_NAV_PX_HEIGHT}px;
  margin: 0 auto;
  max-width: ${containerWidths.xxl}px;
`;
//# sourceMappingURL=BigNav.styles.js.map